import { concat } from "../concat"

export const getBackUrl = (url1?: string | null, url2?: string | null) => {
  return url1 ? concat(url1) : concat(url2)
}
